/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayPauseIcon24Regular = forwardRef('MediaUiAPlayPauseIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.25 5.437c0-1.386 1.535-2.222 2.7-1.47l10.157 6.563a1.75 1.75 0 0 1 0 2.94L3.95 20.033c-1.165.753-2.7-.083-2.7-1.47V5.438Zm1.886-.21a.25.25 0 0 0-.386.21v13.127c0 .198.22.317.386.21l10.157-6.564a.25.25 0 0 0 0-.42L3.136 5.227Z" }),
        React.createElement("path", { d: "M18 3.75a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0v-15a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M23.75 4.5a.75.75 0 0 0-1.5 0v15a.75.75 0 0 0 1.5 0v-15Z" })));
});
